import Config from "@skin_config";
import { getPopupDispatchers } from "@app/dev/contexts/popup";
import { POPUPS } from "@common/constants/popups";
import { getAuthData } from "@common/helpers/auth";
import { swarmRequest } from "@common/helpers/util/requestMiddleware";
import ToastWrapper from '@common/helpers/toastWrapper';

export const confirmation = async (form, betId, isCasino, currencyId) => {
  const { token } = getAuthData();
  const { openPopup } = getPopupDispatchers();

  const inputData = JSON.stringify({ ...form, PhoneNumber: `${form.PhoneNumber.code}${form.PhoneNumber.phone}`, BetId: betId });
  const data = await swarmRequest(
    {
      name: isCasino ? 'CreateWithdrawalRequestFromCasinoBet' : 'CreateWithdrawalRequestFromBet',
      params: {
        Token: token,
        BetId: betId,
        ClientId: Config.main.withdrawalRequest.clientIds[currencyId] || Config.main.withdrawalRequest.clientIds['EUR'],
        PaymentSystemId: Config.main.withdrawalRequest.paymentSystemId,
        Notes: inputData,
      },
    },
    "terminal_command"
  );

  if (data.code === 0) {
    openPopup(POPUPS.REGISTER_SUCCESS, { title: "Success", subTitle: "Your request has been successfully submited" });
  } else if (data.code === 3024) {
    openPopup(POPUPS.ERROR_POPUP, {
      errorMessage: [
        'The ticket with ID {1} has expired. it was valid for {2} days from the calculation date',
        betId,
        Config.main.ticketPayoutExpirationDays,
      ]
    });
  } else {
    ToastWrapper("error", "Something went wrong. Check your details");
  }

  return data.code === 0;
};
